import React, { useEffect, useState } from "react";
import { translate } from "react-switch-lang";
import { Button, Card, CardBody, Col, Form, FormGroup, Input, ModalFooter, Row, Modal, ModalBody } from "reactstrap";
import DatePicker from "react-datepicker";
import styles from "./addMedia.module.scss";
import TableScrollbar from "react-table-scrollbar";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { CategoryDto } from "../../../models/categoryDto";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { ThematicDto } from "../../../models/thematicDto";
import { CountryDto } from "../../../models/countryDto";
import { useForm } from "react-hook-form";
import { Step, Stepper } from "react-form-stepper";
import ReactPlayer from "react-player";
import ImageGallery from "react-image-gallery";
import FileViewer from "../../template/file-viewer/FileViewer";
import { toast } from "react-toastify";
import iconDelete from "../../../assets/images/icons/iconDelete.png";

const AddMedia: React.FC<{
  t: (key: string) => {};
  parentId: number;
  toggle: (isOnCreat: boolean, addClassList: boolean) => void;
  handleGetListFolderThematic: (id: any) => void;
}> = props => {
  toast.configure();
  const pathFolder = "/Mediatheque/Categories/";
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const httpClient = useHttpClient(true);
  const [listCategories, setListCategories] = useState<CategoryDto[]>([]);
  const [listThematic, setListThematic] = useState<ThematicDto[]>([]);
  const [listCountry, setListCountry] = useState<CountryDto[]>([]);
  const [searchFieldDate, setSearchFieldDate] = useState<any>("");
  const [isSearchValid, setIsSearchValid] = useState<boolean>(false);
  const [typeCategory, setTypeCategory] = useState<number>(null);
  const [listMediaOldSelected, setListMediaOldSelected] = useState<any>([]);
  const [listMediaSeleted, setListMediaSelected] = useState<any>([]);
  const [listMedia, setListMedia] = useState([]);
  const [, setListRecoveryMedia] = useState([]);
  const [listMediaOld, setListMediaOld] = useState([]);
  const [searchFiledCategory, setSearchFiledCategory] = useState<any>("");
  const [searchFiledThematic, setSearchFiledThematic] = useState<any>("");
  const [searchFiledCountry, setSearchFiledCountry] = useState<any>("");
  const [searchFiledTitle, setSearchFiledTitle] = useState<any>("");
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = [String(props.t("step_selection")), String(props.t("step_validation"))];
  const [openModalViewer, setOpenModalViewer] = useState<boolean>(false);
  const [openModalVideo, setOpenModalVideo] = useState<boolean>(false);
  const [openImageViewer, setOpenImageViewer] = useState<boolean>(false);
  const [data, setData] = useState<any>();
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const { setValue, getValues } = useForm({
    mode: "onChange",
    defaultValues: {
      title: "",
      categoryId: "",
      thematicId: "",
      countryId: "",
      dateSupport: "",
    },
  });

  useEffect(() => {
    httpClient.current?.get("/thematic_folder_media", { params: { parentId: props.parentId } }).then(response => {
      setListMediaOld(response.data);
    });
    httpClient.current?.get("/category/child", { params: { pathFolder: pathFolder } }).then(response => {
      setListCategories(response.data.filter(category => +category.typeCategory !== 3));
      setTimeout(() => {
        document.body.classList.add("modal-open");
      }, 500);
    });
    httpClient.current?.get("/thematic").then(response => {
      setListThematic(response.data);
      setTimeout(() => {
        document.body.classList.add("modal-open");
      }, 500);
    });
    httpClient.current?.get("/country").then(response => {
      setListCountry(response.data);
      setTimeout(() => {
        document.body.classList.add("modal-open");
      }, 500);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const onCheckBoxChange = async (option, isChecked) => {
    let checkName;
    if (+typeCategory === 2) {
      checkName = option.titleFr;
    } else {
      checkName = option.title;
    }
    let isAllChecked = checkName === false;
    let isAllUnChecked = checkName === "all" && !isChecked;
    const checked = isChecked;

    const checkList = listMedia.map((city, index) => {
      city.index = index;

      if (isAllChecked || city.title === checkName || city.titleFr === checkName) {
        if (isChecked) {
          city.checked = true;
          listMediaSeleted.push(city);
          setListMediaSelected(listMediaSeleted);
        } else {
          if (+typeCategory !== 2) {
            listMediaSeleted.splice(listMediaSeleted.map(item => item.supportId).indexOf(city.supportId), 1);
            setListMediaSelected(listMediaSeleted);
          } else {
            listMediaSeleted.splice(listMediaSeleted.map(item => item.expositionId).indexOf(city.expositionId), 1);
            setListMediaSelected(listMediaSeleted);
          }
        }
        setListMediaOldSelected(listMediaOldSelected);
        return Object.assign({}, city, {
          checked,
        });
      } else if (isAllUnChecked) {
        return Object.assign({}, city, {
          checked: false,
        });
      }

      return city;
    });

    setListMedia(checkList);
  };

  const handleSearch = () => {
    setListMediaSelected([]);
    let data: any = getValues();
    data.sortDirection = "ASC";
    data.sortColumn = "title";
    data.page = "0";
    data.size = "500";
    if (+listCategories.filter(item => item.categoryId === +getValues().categoryId)[0].typeCategory === 0) {
      httpClient.current?.get("/support/search", { params: data }).then(res => {
        setListMedia(
          res.data.content
            .map((data: any) => data.content)
            .filter(
              media =>
                !listMediaOldSelected
                  .filter(oldMedia => oldMedia.categoryId === media.categoryId)
                  .map(item => item.supportId)
                  .includes(media.supportId),
            )
            .filter(
              support =>
                !listMediaOld
                  .filter(oldMedia => oldMedia.categoryId === support.categoryId)
                  .map(media => media.mediaId)
                  .includes(support.supportId),
            ),
        );
        setListRecoveryMedia(
          res.data.content
            .map((data: any) => data.content)
            .filter(media => !listMediaOldSelected.map(item => item.supportId).includes(media.supportId))
            .filter(support => !listMediaOld.map(media => media.mediaId).includes(support.supportId)),
        );
        setTimeout(() => {
          document.body.classList.add("modal-open");
        }, 500);
      });
    } else if (+listCategories.filter(item => item.categoryId === +getValues().categoryId)[0].typeCategory === 1) {
      httpClient.current?.get("/support_video/search", { params: data }).then(res => {
        setListMedia(
          res.data.content
            .map((data: any) => data.content)
            .filter(
              media =>
                !listMediaOldSelected
                  .filter(oldMedia => oldMedia.categoryId === media.categoryId)
                  .map(item => item.supportId)
                  .includes(media.supportId),
            )
            .filter(
              support =>
                !listMediaOld
                  .filter(oldMedia => oldMedia.categoryId === support.categoryId)
                  .map(media => media.mediaId)
                  .includes(support.supportId),
            ),
        );
        setListRecoveryMedia(
          res.data.content
            .map((data: any) => data.content)
            .filter(
              media =>
                !listMediaOldSelected
                  .filter(oldMedia => oldMedia.categoryId === media.categoryId)
                  .map(item => item.supportId)
                  .includes(media.supportId),
            )
            .filter(
              support =>
                !listMediaOld
                  .filter(oldMedia => oldMedia.categoryId === support.categoryId)
                  .map(media => media.mediaId)
                  .includes(support.supportId),
            ),
        );
        setTimeout(() => {
          document.body.classList.add("modal-open");
        }, 500);
      });
    } else {
      data.sortColumn = selectedLanguage === "en" ? "titleEn" : "titleFr";
      if (selectedLanguage === "en") {
        data.titleEn = data.title;
      } else {
        data.titleFr = data.title;
      }
      httpClient.current?.get("/exposition/search", { params: data }).then(res => {
        setListMedia(
          res.data.content
            .map((data: any) => data.content)
            .filter(
              media =>
                !listMediaOldSelected
                  .filter(oldMedia => oldMedia.categoryId === media.categoryId)
                  .map(item => item.expositionId)
                  .includes(media.expositionId),
            )
            .filter(support => !listMediaOld.map(media => media.mediaId).includes(support.expositionId)),
        );
        setListRecoveryMedia(
          res.data.content
            .map((data: any) => data.content)
            .filter(
              media =>
                !listMediaOldSelected
                  .filter(oldMedia => oldMedia.categoryId === media.categoryId)
                  .map(item => item.expositionId)
                  .includes(media.expositionId),
            )
            .filter(support => !listMediaOld.map(media => media.mediaId).includes(support.expositionId)),
        );
        setTimeout(() => {
          document.body.classList.add("modal-open");
        }, 500);
      });
    }
  };

  const checkIsSearchValid = () => {
    setIsSearchValid(getValues().categoryId !== "" && getValues().thematicId !== "");
  };

  const handleAddSelectedMedia = () => {
    // eslint-disable-next-line array-callback-return
    listMediaSeleted.map((item: any, index: number) => {
      listMedia.forEach((element: any, indexElement) => {
        if (+typeCategory !== 2) {
          if (item.supportId === element.supportId) {
            listMedia.splice(indexElement, 1);
            setListMedia(listMedia);
          }
        } else {
          if (item.expositionId === element.expositionId) {
            listMedia.splice(indexElement, 1);
            setListMedia(listMedia);
          }
        }
      });
      // listMedia.splice(item.index - index, 1);
    });

    if (+typeCategory === 2) {
      setListMedia(listMedia.filter(media => !listMediaSeleted.map(item => item.mediaId).includes(media.expositionId)));
    } else {
      setListMedia(listMedia.filter(media => !listMediaSeleted.map(item => item.mediaId).includes(media.supportId)));
    }
    setListMediaOldSelected([...listMediaOldSelected, ...listMediaSeleted]);
    setListMediaSelected([]);
  };

  const handleSubmit = async () => {
    let list = [];
    listMediaOldSelected.forEach(function (item) {});
    listMediaOldSelected.forEach(function (item) {
      list.push({
        mediaId: +listCategories.filter(category => item.categoryId === category.categoryId)[0].typeCategory === 2 ? item.expositionId : item.supportId,
        categoryId: item.categoryId,
        parentId: props.parentId,
        typeCategory: listCategories.filter(category => item.categoryId === category.categoryId)[0].typeCategory,
      });
    });
    httpClient.current?.post("/thematic_folder_media", list).then(response => {
      props.toggle(true, false);
      props.handleGetListFolderThematic(props.parentId);
    });
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleRemoveElementFromSelectedList = (index: number) => {
    setListMediaOldSelected(listMediaOldSelected.filter((element: any, i: number) => i !== index));
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleReset = () => {
    setValue("categoryId", "");
    setValue("thematicId", "");
    setValue("countryId", "");
    setValue("title", "");
    setValue("dateSupport", "");
    setSearchFiledThematic("");
    setSearchFiledCategory("");
    setSearchFiledCountry("");
    setSearchFiledTitle("");
    setSearchFieldDate("");
    setIsSearchValid(false);
  };

  const handleClickView = (data: any) => {
    setData(data);
    if (+listCategories.filter(item => +item.categoryId === +data.categoryId)[0].typeCategory === 0) {
      setOpenModalViewer(!openModalViewer);
    } else if (+listCategories.filter(item => +item.categoryId === +data.categoryId)[0].typeCategory === 1) {
      setOpenModalVideo(!openModalVideo);
    } else {
      setOpenImageViewer(!openImageViewer);
    }
  };

  const handleClickOpenModalViewer = (): void => {
    setOpenModalViewer(!openModalViewer);
  };

  const handleClickOpenModalVideo = (): void => {
    setOpenModalVideo(!openModalVideo);
  };

  const handleClickOpenImageViewer = (): void => {
    setOpenImageViewer(!openImageViewer);
  };

  return (
    <>
      <Stepper className="p-t-0" activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps = label;
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }

          return <Step label={labelProps} key={label} {...stepProps}></Step>;
        })}
      </Stepper>
      {activeStep === 0 ? (
        <>
          <div>
            <Form>
              <Row className={styles["section-search"]}>
                <Col md={4}>
                  <FormGroup>
                    <Input
                      onChange={e => {
                        setSearchFiledCategory(e.target.value);
                        setValue("categoryId", e.target.value);
                        checkIsSearchValid();
                        setTypeCategory(+listCategories.filter(item => item.categoryId === +e.target.value)[0].typeCategory);
                      }}
                      bsSize="sm"
                      defaultValue=""
                      value={searchFiledCategory}
                      placeholder="Catégorie"
                      type="select"
                      name="select"
                      id="category_select"
                    >
                      <option hidden value="">
                        {props.t("filters.input_placeholder_catgory")}
                      </option>
                      {listCategories.map(category => {
                        return <option value={category.categoryId}>{selectedLanguage === "en" ? category.titleAnglais : category.titleFrancais}</option>;
                      })}
                    </Input>
                    {searchFiledCategory && (
                      <i
                        onClick={() => {
                          setValue("categoryId", "");
                          setSearchFiledCategory("");
                          setIsSearchValid(false);
                        }}
                        className={styles["button-reset-input"] + " fa fa-times"}
                      ></i>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Input
                      onChange={e => {
                        setSearchFiledThematic(e.target.value);
                        setValue("thematicId", e.target.value);
                        checkIsSearchValid();
                      }}
                      bsSize="sm"
                      value={searchFiledThematic}
                      type="select"
                      name="select"
                      id="exampleSelect"
                    >
                      <option hidden value="">
                        {props.t("filters.input_placeholder_thematic")}
                      </option>
                      {listThematic.map(thematic => {
                        return <option value={thematic.thematicId}>{selectedLanguage === "en" ? thematic.titleAnglais : thematic.titleFrancais}</option>;
                      })}
                    </Input>
                    {searchFiledThematic && (
                      <i
                        onClick={() => {
                          setValue("thematicId", "");
                          setSearchFiledThematic("");
                          setIsSearchValid(false);
                        }}
                        className={styles["button-reset-input"] + " fa fa-times"}
                      ></i>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Input
                      onChange={e => {
                        setSearchFiledCountry(e.target.value);
                        setValue("countryId", e.target.value);
                      }}
                      value={searchFiledCountry}
                      bsSize="sm"
                      type="select"
                      name="select"
                      id="exampleSelect"
                    >
                      <option hidden value="">
                        {props.t("filters.input_placeholder_country")}
                      </option>
                      {listCountry.map(country => {
                        return <option value={country.countryId}>{selectedLanguage === "en" ? country.titleAnglais : country.titleFrancais}</option>;
                      })}
                    </Input>
                    {searchFiledCountry && (
                      <i
                        onClick={() => {
                          setValue("countryId", "");
                          setSearchFiledCountry("");
                        }}
                        className={styles["button-reset-input"] + " fa fa-times"}
                      ></i>
                    )}
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Input
                      onChange={e => {
                        setSearchFiledTitle(e.target.value);
                        setValue("title", e.target.value);
                      }}
                      value={searchFiledTitle}
                      placeholder="Nom"
                      bsSize="sm"
                    ></Input>
                    {searchFiledTitle && (
                      <i
                        onClick={() => {
                          setValue("title", "");
                          setSearchFiledTitle("");
                        }}
                        className={styles["button-reset-input"] + " fa fa-times"}
                      ></i>
                    )}
                  </FormGroup>
                </Col>
                <Col md="5">
                  <FormGroup>
                    <DatePicker
                      className={styles["date-picker"] + " form-control"}
                      selected={searchFieldDate ? new Date(searchFieldDate) : null}
                      onChange={(e: Date) => {
                        setValue("dateSupport", e.getFullYear().toString());
                        setSearchFieldDate(String(e?.getFullYear()));
                      }}
                      maxDate={new Date()}
                      placeholderText={String(props.t("filters.input_placeholder_date"))}
                      dateFormat="yyyy"
                      showYearPicker
                    />
                    {searchFieldDate && (
                      <i
                        onClick={() => {
                          setValue("dateSupport", "");
                          setSearchFieldDate("");
                        }}
                        className={styles["button-reset-input"] + " fa fa-times"}
                      ></i>
                    )}
                  </FormGroup>
                </Col>
                <Col md="1" className="p-t-10">
                  {isSearchValid ? (
                    <i
                      onClick={() => {
                        handleSearch();
                      }}
                      className={styles["icon-search"] + " fa fa-search"}
                    ></i>
                  ) : (
                    <i className={styles["icon-search-disable"] + " fa fa-search"}></i>
                  )}

                  <i
                    title={String(props.t("label_reinit"))}
                    onClick={() => {
                      handleReset();
                    }}
                    className={styles["icon-refresh"] + " m-l-10 fa fa-refresh"}
                  ></i>
                </Col>
              </Row>
            </Form>
            <Card className="m-b-0">
              <CardBody className="p-10">
                <TableScrollbar height="200px">
                  <table className={styles["table-data"]}>
                    <thead className={styles["table-head"]}>
                      <tr>
                        <th className={styles["table-column-checkbox"] + " text-center"}></th>
                        <th className={styles["table-column-title"]}>{props.t("table_header.title")}</th>
                        <th className={styles["table-column-title"]}>{props.t("table_header.country")}</th>
                        <th className={styles["table-column-year"]}>{props.t("table_header.date")}</th>
                        <th className={styles["table-column-view"] + " text-center"}></th>
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll" }}>
                      <div className={styles["no-data-search"]}>{listMedia.length === 0 && <h6>{props.t("message_no_media")}</h6>}</div>

                      {listMedia.map(option => {
                        return (
                          <>
                            <tr className={styles["table-line-data"]}>
                              <td className={styles["table-column-checkbox"] + " text-center"}>
                                <input
                                  name={+typeCategory === 2 ? option.titleFr : option.title}
                                  type="checkbox"
                                  value={+typeCategory === 2 ? option.titleFr : option.title}
                                  checked={option.checked || false}
                                  onChange={e => {
                                    onCheckBoxChange(option, e.target.checked);
                                  }}
                                />
                              </td>
                              <td className={styles["table-column-title"]}>
                                {option?.title}
                                {selectedLanguage === "en" ? option.titleEn : option.titleFr}
                              </td>
                              <td className={styles["table-column-title"]}>
                                {option?.listCountry?.map(country => {
                                  return selectedLanguage === "en" ? country.titleAnglais : country.titleFrancais;
                                })}
                              </td>
                              <td>
                                {option?.dateSupport}
                                {option?.dateExposition}
                              </td>
                              <td className="text-center">
                                <i
                                  onClick={() => {
                                    handleClickView(option);
                                  }}
                                  className={styles["icon-eye"] + " fa fa-eye "}
                                ></i>{" "}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </TableScrollbar>

                <div className="float-right ">
                  <Button onClick={handleAddSelectedMedia} outline color="success" className={styles["btn-add-media"] + " m-t-10 m-r-10"}>
                    <i className="fa fa-plus"></i>
                  </Button>
                </div>
              </CardBody>
            </Card>
          </div>
        </>
      ) : (
        <TableScrollbar height="100%">
          <table className={styles["table-data"]}>
            <thead className={styles["table-head"]}>
              <tr>
                <th className={styles["table-column-checkbox"] + " text-center"}></th>
                <th className={styles["table-column-selected-title"]}>{props.t("table_header.title")}</th>
                <th className={styles["table-column-selected-country"]}>{props.t("table_header.country")}</th>
                <th className={styles["table-column-selected-country"]}>{props.t("table_header.date")}</th>
                <th className={styles["table-column-selected-country"]}>{"Type"}</th>
                <th className={styles["table-column-view"] + " text-center"}></th>
              </tr>
            </thead>
            <tbody style={{ overflowY: "scroll" }}>
              <div className={styles["no-data-search"]}>{listMediaOldSelected.length === 0 && <h6>{props.t("message_no_media_selected")}</h6>}</div>
              {listMediaOldSelected.map((option, index) => {
                return (
                  <>
                    <tr className={styles["table-line-data"]}>
                      <td className={styles["table-column-checkbox"] + " text-center"}>
                        {/* <i onClick={() => handleRemoveElementFromSelectedList(index)} className={styles["icon-minus"] + " fa fa-minus"}></i> */}
                        <img onClick={() => handleRemoveElementFromSelectedList(index)} className={styles["icon-minus"]} src={iconDelete} alt="" title={String(props.t("button_remove"))} />
                      </td>
                      <td className={styles["table-column-selected-title"]}>
                        {option?.supportVideo?.title}
                        {option?.support?.title}
                        {selectedLanguage === "en" ? option?.titleEn : option?.titleFr}
                        {option?.title}
                      </td>
                      <td className={styles["table-column-selected-country"]}>
                        {option?.listCountry?.map(country => {
                          return selectedLanguage === "en" ? country.titleAnglais : country.titleFrancais;
                        })}
                      </td>
                      <td>
                        {option?.dateSupport}
                        {option?.dateExposition}
                      </td>
                      <td>
                        {+listCategories.filter(category => option.categoryId === category.categoryId)[0].typeCategory === 0
                          ? props.t("category.label_bibliotheque")
                          : +listCategories.filter(category => option.categoryId === category.categoryId)[0].typeCategory === 1
                          ? props.t("category.label_videotheque")
                          : props.t("category.label_exhibit")}
                      </td>
                      <td className="text-center">
                        <i
                          onClick={() => {
                            handleClickView(option);
                          }}
                          className={styles["icon-eye"] + " fa fa-eye "}
                        ></i>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </TableScrollbar>
      )}
      <ModalFooter className={styles["footer-style"] + " p-b-0 p-t-5"}>
        <>
          <Col md={12}>
            <Button
              className={styles["back"] + " float-left"}
              onClick={() => {
                props.toggle(true, false);
              }}
            >
              ANNULER
            </Button>

            {activeStep === steps.length - 1 ? (
              <Button color="success" className={styles["submit"]} disabled={listMediaOldSelected.length === 0} onClick={handleSubmit} sx={{ mr: 1 }}>
                {props.t("button_submit")}
              </Button>
            ) : (
              <Button
                color="success"
                disabled={activeStep === 0 && false}
                className={styles["submit"]}
                onClick={() => {
                  handleAddSelectedMedia();
                  handleNext();
                }}
              >
                {props.t("button_next")}
              </Button>
            )}
            {activeStep !== 0 && (
              <Button className={styles["cancel"]} onClick={handleBack} sx={{ mr: 1 }}>
                {props.t("button_previous")}
              </Button>
            )}
          </Col>
        </>
      </ModalFooter>

      <Modal isOpen={openModalViewer} toggle={() => handleClickOpenModalViewer()} size="xl">
        <ModalBody>
          <FileViewer src={data?.urlSupport} width={"100%"} height={"580"} />
        </ModalBody>
      </Modal>

      <Modal isOpen={openModalVideo} toggle={() => handleClickOpenModalVideo()} size="xl">
        <ModalBody>
          <ReactPlayer
            url={data?.link}
            width="100%"
            height="82vh"
            onError={() => {
              toast.error(props.t("message_toastr_inaccessible_video"), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
            }}
            playing={data?.urlSupport ? true : false}
            controls={true}
            light={data?.urlSupport ? data?.urlSupport + "/preview" : false}
          />
        </ModalBody>
      </Modal>
      <Modal isOpen={openImageViewer} toggle={() => handleClickOpenImageViewer()} size="lg">
        <ModalBody>
          <ImageGallery
            items={data?.listExpositionImage?.map((image: any) => {
              return { original: image.urlImage, thumbnail: image.urlImage };
            })}
            thumbnailPosition={"bottom"}
            showBullets={true}
            showPlayButton={true}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(AddMedia);
